import {HttpServices} from "../Helpers";
import urls from "../api/urls";

export const GetAllCandidatesSearchDBNewV2 = async ({
  use_for = "search_db",
  limit = 12,
  page = 1,
  params,
  arrays = {},
  search,
  isDropdown,
}) => {
  let queryString = "";
  Object.keys(arrays).forEach((key) => {
    if (arrays[key])
      arrays[key].forEach((value) => {
        queryString = `${queryString}&${key}=${value}`;
      });
  });

  return await HttpServices.post(
    `${process.env.REACT_APP_ANALYTICS_SDB_API}/dynamic-analytics/candidate/index`,
    {
      ...params,
      use_for,
      page,
      limit,
      ...arrays,
      ...(isDropdown && search && {query: [search]}),
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};
export const GetCandidatesDetailsById = async ({profile_uuid}) => {
  const queryList = [];
  if (profile_uuid) queryList.push(`profile_uuid=${profile_uuid}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_INDEXER_API}/api/${
      process.env.REACT_APP_VERSION_API
    }/candidate/profile?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const GetEvaluation = async ({candidate_uuid, job_uuid}) => {
  const result = await HttpServices.get(urls.evarec.ats.CANDIDATE_EVALUATION, {
    params: {
      candidate_uuid,
      job_uuid,
    },
  })
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
